import * as types from '../action_types'

const NewRowData = {
  // slctdCnsgnmntType: '',
  // description: '',
  // pack_method: '',
  // unit: '0',
  // goods_value: '0',
  // wt_actual: '0',
  // wt_volume: '0',
  // wt_charge: '0',
  // rate: '0',
  // freight: '0',
  // wt_vlm_len: '0',
  // wt_vlm_wid: '0',
  // wt_vlm_ht: '0',
  // unitType: 'MM',
  // action: '',
  // slctdCnsgnmntType: {},
  // slctdMethodOfPckgType: {},
  ActualWeight: '0',
  BookingDetID: '',
  BookingID: '',
  ChargedWeight: '0',
  ConsignmentSubTypeID: '0',
  Description: '',
  Freight: '0',
  GoodsValue: '0',
  Mopid: '0',
  Quantity: '0',
  Rate: '0',
  SubType: ' ',
  Volume: '',
  mop: ' ',
  slctdCnsgnmntType: {},
  unitType: 'MM',
  wt_vlm_ht: '0',
  wt_vlm_len: '0',
  wt_vlm_wid: '0',
}
const initialState = {
  loader: false,
  error: false,
  showModal: false,
  modalType: '',
  userData: [],
  loginData: {},
  selectedActvty: 'booking',
  companySettings: [],
  gstConfig: {},
  parentCompnayData: [],
  bookingParentCompanyData: [],
  companyBookingPermission: {},
  cmpnyTax: {},
  searchLrData: [],
  RechargeList: [],
  ServerDateTime: '',
  roleRights: [],
  cityList: [],
  strtCityList: [],
  destCityList: [],
  brnchList: [],
  strtBrnchList: [],
  adminBranchList: [],
  destBrnchList: [],
  strtCity: {},
  strtBrnch: {},
  destCity: {},
  destBrnch: {},
  cityDistance: 0,
  senderPartyList: [],
  receiverPartyList: [],
  slctdSndParty: {},
  slctdRcvrParty: {},
  cnsgnmntTypes: [],
  methodOfPckgTypes: [],
  slctdCnsgnmntType: {},
  slctdMethodOfPckgType: {},
  selBookingType: {},
  selPaymentType: {},
  selSearchBy: {},
  pricingInquiry: [],
  BookedPnrData: {},
  focApproverList: [],
  branchCreditLimit: [],
  destBranchCreditLimit: [],
  lastLR: {},
  ewayBillAuthDetails: {},
  ewayBillDetailsList: [],
  selectedLrNumber: '',
  alert: { show: false, msg: 'Oops! some error occured!', nextId: '', close: false },
  getIdProof: [],
  partyList: [],
  OtpDetail: {},
  OTP: [],
  delivery: [],
  cancelDelivery: [],
  printDelivery: [],
  rePrintDelivery: [],
  ticketFormat: [],
  ticketReprintFormat: [],
  waybillFormats: [],
  selectedFormatDetail: false,
  loginData2: [],
  branchConfiguration: [],
  citywiseBranchList: [],
  //  for delivery bottum color
  deliveybktId: '',

  //branch transfer states
  vehicleList: [],
  driverInfo: [],
  citiesBranchList: [],
  allStates: [],
  listData: [],
  branchTransfer: [],
  brachTransferCancelList: [],
  cancelBranchTransfer: [],
  printMemo: [],
  checkingReport: [],
  updateTransfer: [],
  getChallanNumber: [],
  //Dashboard data
  dispatchDashboard: [],
  BranchReceiveDashboard: [],
  ReceiveDashboard: [],
  ModifyData: [],
  //Dashboard data end
  gstnValidationData: { isRecve: false, showPopup: false },
  senderGSTNdata: {},
  receiverGSTNdata: {},
  bookingCancelResponse: {},
  // for mehtod of payment
  methodOfPayment: [],
  bankAccountDetail: [],
  setGApiKey: {},
  //Delivery Memo state
  deliveryMemoList: [],
  userList: [],
  lrDetailsData: {},
  companyCityList: [],
  weightChrgData: {},
  getPolicyData: {},
  setRollRightsData: {},
  cityBranchMatrix: {},
  ftlCityListAll: [],
  ewayBillExemptedItems: [],
}

const commonReducer = function (state = initialState, action) {
  let stateL = { ...state }
  let modifyDataL = JSON.parse(JSON.stringify(stateL.ModifyData))
  const { data, type } = { ...action }
  switch (action.type) {
    case types.LOADER:
      return {
        ...state,
        loader: action.data,
      }
    case types.MODAL:
      return {
        ...state,
        showModal: action.data,
        modalType: action.modalType,
      }
    case types.LOGIN:
      return {
        ...state,
        loginData: action.data || {},
        loginData2: action.data1 || [],
      }
    case types.USER_DATA:
      return {
        ...state,
        userData: action.data,
      }
    case types.COMPANY_SETTINGS:
      return {
        ...state,
        companySettings: action.data,
      }
    case types.COMPANY_TAX:
      return {
        ...state,
        cmpnyTax: action.data,
      }
    case types.SEARCH_LR_Data:
      return {
        ...state,
        searchLrData: action.data,
      }
    case types.Modify_Data:
      return {
        ...state,
        ModifyData: action.data,
        ModifyData1: action.data1,
      }
    case types.lrDetails_data:
      return {
        ...state,
        lrDetailsData: action.data,
      }
    //for admin update Modify data
    case types.ADD_NEW_MODIFY_ROW:
      modifyDataL.push({ ...NewRowData })
      return Object.assign({}, state, {
        ModifyData: modifyDataL,
      })
    case types.REMOVE_MODIFY_ROW:
      modifyDataL.splice(action.index, 1)
      return Object.assign({}, state, {
        ModifyData: modifyDataL,
      })
    case types.MODIFY_SECTION_DATA:
      const currentModifyData = modifyDataL.slice()
      currentModifyData[action.param][action.key] = data
      const cnsgnmntData =
        action.cnsgnmntTypes.length > 0 ? action.cnsgnmntTypes.find(({ ConsignmentSubTypeID }) => ConsignmentSubTypeID == data) : ''
      currentModifyData[action.param].slctdCnsgnmntType =
        cnsgnmntData == '' ? currentModifyData[action.param].slctdCnsgnmntType : cnsgnmntData
      return { ...state, ModifyData: currentModifyData }

    case types.Modify_ROW:
      modifyDataL[action.param] = { ...data }
      return { ...state, ModifyData: modifyDataL }
    case types.Recharge_List:
      return {
        ...state,
        RechargeList: action.data,
      }
    case types.Recharge_Party_List:
      return {
        ...state,
        RechargePartyList: action.data,
      }
    case types.Recharge_Payment_List:
      return {
        ...state,
        RechargePaymentList: action.data,
      }

    case types.Server_Date_Time:
      return {
        ...state,
        ServerDateTime: action.data,
      }

    case types.SELECTED_ACTIVITY:
      return {
        ...state,
        selectedActvty: action.data,
        strtCity: {},
        strtBrnch: {},
        destCity: {},
        destBrnch: {},
        senderPartyList: [],
        receiverPartyList: [],
        slctdSndParty: {},
        slctdRcvrParty: {},
        // cnsgnmntTypes:[],
        // methodOfPckgTypes:[],
        slctdCnsgnmntType: {},
        slctdMethodOfPckgType: {},
        selBookingType: {},
        selectedLrNumber: '',
      }
    case types.SELECTED_LR_NUMBER:
      return {
        ...state,
        selectedLrNumber: action.data,
      }
    case types.ROLE_RIGHTS:
      return {
        ...state,
        roleRights: action.data,
      }
    case types.CITY_LIST:
      const cityList = action.data || []
      return {
        ...state,
        cityList,
      }
    case types.STRT_CITY_LIST:
      const strtCityList = action.data || []
      return {
        ...state,
        strtCityList,
      }
    case types.DEST_CITY_LIST:
      const destCityList = action.data || []
      return {
        ...state,
        destCityList,
      }
    case types.BRANCH_LIST:
      const brnchList = action.data || []
      return {
        ...state,
        brnchList,
      }
    case types.STRT_BRANCH_LIST:
      const strtBrnchList = action.data || []
      return {
        ...state,
        strtBrnchList,
      }
    case types.ADMIN_BRANCH_LIST:
      const adminBranchList = action.data || []
      return {
        ...state,
        adminBranchList,
      }

    case types.DEST_BRANCH_LIST:
      const destBrnchList = action.data || []
      return {
        ...state,
        destBrnchList,
      }
    case types.STRT_CITY:
      return {
        ...state,
        strtCity: action.data,
      }
    case types.STRT_BRNCH:
      return {
        ...state,
        strtBrnch: action.data,
      }
    case types.DEST_CITY:
      return {
        ...state,
        destCity: action.data,
      }
    case types.CITY_DISTANCE:
      return {
        ...state,
        cityDistance: action.data,
      }
    case types.DEST_BRNCH:
      return {
        ...state,
        destBrnch: action.data,
      }
    case types.BOOKING_TYPE:
      return {
        ...state,
        selBookingType: action.data,
      }
    case types.SEL_PAYMENT_TYPES:
      return {
        ...state,
        selPaymentType: action.data,
      }
    case types.SEL_SEARCH_BY:
      return {
        ...state,
        selSearchBy: action.data,
      }
    case types.PRICING_INQUIRY:
      return {
        ...state,
        pricingInquiry: action.data,
      }

    //     case types.SEL_PAYMENT_TYPES:
    // const selPaymentType = (action.data || []).sort((a, b) => a.name.localeCompare(b.name))
    // return {
    //   ...state,
    //   selPaymentType,
    // }
    case types.OTP_Detail:
      return {
        ...state,
        OtpDetail: action.data,
      }
    case types.PARTY_LIST:
      return {
        ...state,
        [!action.isRcv ? `senderPartyList` : `receiverPartyList`]: action.data || [],
        partyList: action.data,
      }
    case types.PARTY:
      return {
        ...state,
        [!action.isRcv ? `slctdSndParty` : `slctdRcvrParty`]: action.data || [],
      }
    case types.CONSIGNMENT_TYPES:
      const cnsgnmntTypes = (action.data || []).sort((a, b) => a.SubType.localeCompare(b.SubType))
      return {
        ...state,
        cnsgnmntTypes,
      }
    case types.METHOD_OF_PACKING_TYPES:
      return {
        ...state,
        methodOfPckgTypes: action.data || [],
      }
    case types.CONSIGNMENT_TYPE:
      let sCtype = action.data
      let slctdMethodOfPckgTypeL =
        sCtype?.DefaultMOPId !== undefined && sCtype.DefaultMOPId
          ? state.methodOfPckgTypes.find(({ MOPID }) => MOPID == sCtype.DefaultMOPId)
          : {}
      return {
        ...state,
        slctdCnsgnmntType: sCtype,
        slctdMethodOfPckgType: slctdMethodOfPckgTypeL,
      }
    case types.METHOD_OF_PACKING_TYPE:
      return {
        ...state,
        slctdMethodOfPckgType: action.data,
      }
    case types.BOOKED_PNR_DATA:
      return {
        ...state,
        BookedPnrData: action.data,
      }
    case types.FOC_APPROV_LIST:
      const focApproverList = action.data || []
      return {
        ...state,
        focApproverList,
      }
    case types.BRANCH_CREDIT_LIMIT:
      const branchCreditLimit = action.data || []
      return {
        ...state,
        branchCreditLimit,
      }
    case types.DEST_BRANCH_CREDIT_LIMIT:
      const destBranchCreditLimit = action.data || []
      return {
        ...state,
        destBranchCreditLimit,
      }

    case types.LAST_LR:
      const lastLR = action.data || {}
      return {
        ...state,
        lastLR,
      }
    case types.EWB_AUTH_DETAILS:
      const ewayBillAuthDetails = action.data || {}
      return {
        ...state,
        ewayBillAuthDetails,
      }
    case types.ADD_EWB_DETAILS:
      const ewayBillDetailsdata = action.data || ''
      const ewayBillDetailsList = ewayBillDetailsdata ? [...state.ewayBillDetailsList, ewayBillDetailsdata] : state.ewayBillDetailsList
      return {
        ...state,
        ewayBillDetailsList,
      }
    case types.REMOVE_EWB_DETAILS:
      const eWayBillNo = action.data || {}
      const filterewayBillDetailsList = state.ewayBillDetailsList.filter((item) => item.EWBNo !== eWayBillNo)
      return {
        ...state,
        ewayBillDetailsList: filterewayBillDetailsList,
      }
    case types.RESET_EWB_DETAILS:
      return {
        ...state,
        ewayBillDetailsList: [],
      }
    case types.RESET_ACTIVITY_DATA:
      return {
        ...state,
        strtCity: {},
        strtBrnch: {},
        destCity: {},
        destBrnch: {},
        slctdSndParty: {},
        slctdRcvrParty: {},
        selBookingType: {},
        selectedLrNumber: '',
      }
    case types.ALERT:
      return {
        ...state,
        alert: action.data,
      }
    case types.GET_ID_PROOF:
      return {
        ...state,
        getIdProof: action.data,
      }

    case types.GET_POST_DELIVERY:
      return {
        ...state,
        delivery: action.data,
      }
    case types.CANCEL_DELIVERY:
      return {
        ...state,
        cancelDelivery: action.data,
      }
    // case types.GET_PRINT_DELIVERY:
    //   return {
    //     ...state,
    //     [action.isReprint ? `rePrintDelivery` : `printDelivery`]: action.data,
    //   }
    case types.GET_PRINT_DELIVERY:
      return {
        ...state,
        printDelivery: action.isReprint ? [] : action.data,
        rePrintDelivery: action.isReprint ? action.data : [],
      };
    case types.GET_TICKET_FORMAT:
      return {
        ...state,
        [action.isReprint ? `ticketReprintFormat` : `ticketFormat`]: action.data,
        printType: action.printType,
      }
    case types.ALL_PRINT_FORMAT_LIST:
      return {
        ...state,
        waybillFormats: data,
      }
    case types.SELECTED_FORMAT_DETAIL:
      return {
        ...state,
        selectedFormatDetail: data,
      }
    case types.CURRENT_ADDRESS:
      return {
        ...state,
        currentAddress: action.data,
      }
    case types.GMAP_KEY: {
      return {
        ...state,
        gmapKey: action.data,
      }
    }
    case types.LR_STATUS: {
      return {
        ...state,
        lrStatus: action.data,
      }
    }
    case types.LR_STATUS_Cancel_Trasaction: {
      return {
        ...state,
        lrStatusCancelTransaction: action.data,
      }
    }

    case types.OTP_REQ: {
      return {
        ...state,
        OTP: action.data,
      }
    }
    //Branch Transfer cases

    case types.VEHICLE_LIST:
      return {
        ...state,
        vehicleList: action.data,
      }

    case types.DRIVER_INFO_LIST:
      return {
        ...state,
        driverInfo: action.data,
      }
    case types.DEST_CITIES_BRANCH_LIST:
      return {
        ...state,
        citiesBranchList: action.data,
      }
    case types.ALL_STATES:
      return {
        ...state,
        allStates: action.data,
      }
    case types.LIST_DATA:
      return {
        ...state,
        listData: action.data,
      }
    case types.BRANCH_TRANSFER:
      return {
        ...state,
        branchTransfer: action.data,
      }
    case types.BRANCH_TRANSFER_CANCEL_LIST:
      return {
        ...state,
        brachTransferCancelList: action.data,
      }
    case types.BRANCH_TRANSFER_CANCEL:
      return {
        ...state,
        cancelBranchTransfer: action.data,
      }
    case types.PRINT_MEMO:
      return {
        ...state,
        printMemo: action.data,
      }
    case types.CHECKING_REPORT:
      return {
        ...state,
        checkingReport: action.data,
      }
    case types.UPDATE_TRANSFER:
      return {
        ...state,
        updateTransfer: action.data,
      }
    case types.UPDATE_GET_CHALLAN_NUMBER:
      return {
        ...state,
        getChallanNumber: action.data,
      }
    case types.VALIDATE_GSTN:
      return {
        ...state,
        gstnValidationData: action.data,
        [action.data.isRecve ? `receiverGSTNdata` : `senderGSTNdata`]: action.data.data || [],
      }
    case types.DASHBOARD_DISPATCH_DETAILS:
      return {
        ...state,
        dispatchDashboard: action.data,
      }
    case types.DASHBOARD_BRANCHRECEIVE_DETAILS:
      return {
        ...state,
        BranchReceiveDashboard: action.data,
      }
    case types.DASHBOARD_RECEIVE_DETAILS:
      return {
        ...state,
        ReceiveDashboard: action.data,
      }
    case types.BRANCH_CONFIGURATION:
      return {
        ...state,
        branchConfiguration: action.data,
        citywiseBranchList: action.data1,
      }

    case types.PARENT_COMPANY_DATA:
      let temp = state.parentCompnayData
      let keys = Object.keys(action.data)
      temp[keys[0]] = { ...action.data[keys[0]] }
      return {
        ...state,
        [action?.isBooking ? `bookingParentCompanyData` : `parentCompnayData`]: temp,
      }
    case types.BOOKING_PERMISSION_DATA:
      return {
        ...state,
        companyBookingPermission: action.data,
      }
    case types.GST_CONFIG:
      return {
        ...state,
        gstConfig: action.data,
      }
    case types.BOOKING_REFUND:
      return {
        ...state,
        bookingCancelResponse: action.data,
      }
    case types.DELIVERY_BOOKINGTYPE_ID:
      return {
        ...state,
        deliveybktId: action.data,
      }
    case types.METHO_OF_PAYMENT:
      return {
        ...state,
        methodOfPayment: action.data,
      }
    case types.BANK_ACCOUNT_DETAILS:
      return {
        ...state,
        bankAccountDetail: action.data,
      }
    case types.SET_GOOGLE_APIKEY:
      return {
        ...state,
        setGApiKey: action.data,
      }

    case types.DELIVERY_MEMO_LIST:
      return {
        ...state,
        deliveryMemoList: action.data,
      }

    case types.USER_LIST:
      return {
        ...state,
        userList: action.data,
      }
    case types.COMP_CITY_LIST:
      return {
        ...state,
        companyCityList: action.data,
      }
    case types.WEIGHT_CHARGE:
      return {
        ...state,
        weightChrgData: { ...state.weightChrgData, [action.index]: action.data },
      }
    case types.GET_POLICY_RIGHTS:
      return {
        ...state,
        getPolicyData: action.data,
      }
    case types.SET_ROLL_RIGHTS:
      return {
        ...state,
        setRollRightsData: action.data,
      }
    case types.CITY_BRANCH_MATRIX:
      return {
        ...state,
        cityBranchMatrix: {
          ...state.cityBranchMatrix,
          [action.cityID]: action.data,
        },
      }
    case types.FTL_CITY_LIST:
      return {
        ...state,
        ftlCityListAll: action.data,
      }
    case types.EWAY_BILL_EXMPTED:
      return {
        ...state,
        ewayBillExemptedItems: action.data,
      }
    default:
      return state
  }
}

export default commonReducer
